module.exports = __webpack_public_path__ + "images/emoji/ok.5385ee6fca220c3a3446.png";